import { Popup } from '@approvalmax/ui/src/components';
import { useAtom } from 'jotai';
import { memo, useCallback, useState } from 'react';

import { ConfirmConvertCurrencyPopupContent, ConvertCurrencyPopupContent } from './components';
import { convertCurrencyPopupState } from './ConvertCurrencyPopup.states';
import { ConversionData } from './ConvertCurrencyPopup.types';

export const ConvertCurrencyPopup = memo(() => {
    const [popupState, setPopupState] = useAtom(convertCurrencyPopupState);

    const [step, setStep] = useState<'convert' | 'confirm'>('convert');
    const [submittedData, setSubmittedData] = useState<ConversionData | null>(null);

    const handleTogglePopup = useCallback(
        (open: boolean) => {
            setPopupState((current) => ({
                ...current,
                isOpen: open,
            }));

            if (!open) {
                setSubmittedData(null);
            }
        },
        [setPopupState]
    );

    const handleSubmit = useCallback((data: ConversionData) => {
        setSubmittedData(data);
        setStep('confirm');
    }, []);

    const setConvertStep = useCallback(() => {
        setStep('convert');
    }, []);

    const onConfirmSuccess = useCallback(() => {
        setConvertStep();
        setSubmittedData(null);
    }, [setConvertStep]);

    return (
        <Popup open={popupState.isOpen} size='small' onToggle={handleTogglePopup}>
            {step === 'confirm' && submittedData && (
                <ConfirmConvertCurrencyPopupContent
                    {...submittedData}
                    companyId={popupState.companyId}
                    onSuccess={onConfirmSuccess}
                    onBack={setConvertStep}
                />
            )}

            {(step === 'convert' || !submittedData) && (
                <ConvertCurrencyPopupContent onSubmit={handleSubmit} conversionData={submittedData} />
            )}
        </Popup>
    );
});

ConvertCurrencyPopup.displayName = 'ConvertCurrencyPopup';
